<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialogHelp"
      scrollable
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title
          class="white--text headline teal pl-5 pt-3 font-weight-bold"
          primary-title
        >
          Informações sobre o uso do sistema
          <v-spacer />
          <v-btn
            icon
            @click="alterarDialogHelp()"
          >
            <v-icon color="white">
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: 350px;">
          <v-container grid-list-md>
            <div
              v-for="(itemHelp,i) in listaHelp"
              :key="i"
            >
              <h3 class="headline mb-0">
                <div class="text-sm-center teal--text font-weight-bold">
                  {{ itemHelp[0].titulo }}
                </div>
              </h3>
              <v-divider />
              <v-layout wrap>
                <v-expansion-panels
                  focusable
                  popout
                >
                  <v-expansion-panel
                    v-for="(item, i) in itemHelp"
                    :key="i"
                  >
                    <v-expansion-panel-header>
                      <div class="font-weight-bold">
                        {{ item.subtitulo }}
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      {{ item.texto }}
                    </v-expansion-panel-content>
                    <!-- <template v-slot:header>
                      <div class="font-weight-bold">
                        {{ item.subtitulo }}
                      </div>
                    </template>
                    <v-card>
                      <v-card-text>{{ item.texto }}</v-card-text>
                    </v-card> -->
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-layout>
              <br>
            </div>
          </v-container>
          <small v-show="false">* caso persista alguma dúvida em relação ao uso do sistema, ligue para (75) 98230-2308.</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-3"
            text
            @click="alterarDialogHelp()"
          >
            Fechar
          </v-btn>
          <!-- <v-btn color="blue darken-1" text @click="dialogHelp = false">Save</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// import Cookies from 'js-cookie'

export default {
  props: {
    listaHelp: {
      type: Array,
      default: () => ([])
    },
    dialogHelp: Boolean,
    descricaoDialogo: String
  },
  data () {
    return {
      page: 1
      // dialogHelp:false,
    }
  },

  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
  },
  created () {
    console.log('created...')
  },
  methods: {
    alterarDadosFuncionario (item) {
      console.log(item)
      this.$emit('alterar-dados-funcionario', item, this.tipoFuncionario) // emit para o pai
    },

    alterarDialogHelp () {
      this.$emit('alterar-dialog-help')
    }

  }
}
</script>

<style  scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
